export enum USER_VALUE_DIRECTION {
  PLUS = "PLUS",
  MINUS = "MINUS",
}
